/**
 * AI 工作區共用 API client
 * 對應後端 app/ee/ai/workspace/
 */

import axios from './axios';
import {
  AI_WORKSPACE_API_BASE,
  URL_PRECHECK_TIMEOUT_MS,
} from './aiWorkspaceConstants';

export interface UrlPrecheckResult {
  ok: boolean;
  status_code: number;
  content_type: string;
  warning: string | null;
}

/** HEAD/GET 檢查 URL 是否存活（給 ACTION 卡片渲染前先標出問題來源） */
export const urlPrecheck = async (
  url: string,
  source_type?: string,
): Promise<UrlPrecheckResult> => {
  const res = await axios.post(`${AI_WORKSPACE_API_BASE}/url_precheck`,
                               { url, source_type },
                               { timeout: URL_PRECHECK_TIMEOUT_MS });
  return res.data;
};
